import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
    fetch() {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getRuleEventTypes {
                        id
                        name,
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    fetchWhere(name) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    getRuleEventTypes (
                        name: "${name}",
                    ) {
                        id
                        name,
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    update(id, data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        data.chosen_instances = data.chosen_instances ? data.chosen_instances : []
        return axios.post('', {
            query: `
                mutation {
                    updateRuleEventType (
                        id: ${id},
                        name: "${data.name}"
                    ) {
                        id
                        name,
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    create(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        data.chosen_instances = data.chosen_instances ? data.chosen_instances : []
        return axios.post('', {
            query: `
                mutation {
                    createRuleEventType (
                        name: "${data.name}"
                    ) {
                        id
                        name,
                        created_at,
                        updated_at
                    }
                }
            `
        })
    },
    delete(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                mutation {
                    deleteRuleEventType (
                        id: ${id}
                    )
                }
            `
        })
    }
}